/* שילוח הקן — behaviour. No dependencies. Safe to load with `defer` on every page. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  /* ---------- Header: transparent over video → solid after 80px ---------- */
  function initHeader() {
    var header = document.querySelector('.sh-header--over-video');
    if (!header) return;
    var threshold = 80;
    var ticking = false;
    function update() {
      header.classList.toggle('is-solid', window.scrollY > threshold);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Hero video: autoplay policy, pause control (WCAG 2.2.2) ---------- */
  function initHero() {
    var hero = document.querySelector('.sh-hero');
    if (!hero) return;
    var video = hero.querySelector('.sh-hero__media');
    var pauseBtn = hero.querySelector('.sh-hero__pause');
    if (!video) return;

    if (reduceMotion.matches || saveData) {
      video.removeAttribute('autoplay');
      video.pause();
      hero.classList.add('is-poster');
      return;
    }

    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () { hero.classList.add('is-poster'); });
    }

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        var paused = video.paused;
        if (paused) { video.play(); } else { video.pause(); }
        pauseBtn.setAttribute('aria-pressed', paused ? 'false' : 'true');
        pauseBtn.setAttribute('aria-label', paused ? pauseBtn.dataset.labelPause : pauseBtn.dataset.labelPlay);
      });
    }
  }

  /* ---------- Meter calculator ---------- */
  var KITS = [
    { key: 'short',   name: 'מעקה קצר', strips: 9,  meters: 3 },
    { key: 'balcony', name: 'מרפסת',    strips: 18, meters: 6 },
    { key: 'full',    name: 'בית מלא',  strips: 30, meters: 10 }
  ];

  function pickKit(meters) {
    for (var i = 0; i < KITS.length; i++) if (meters <= KITS[i].meters) return KITS[i];
    return null;
  }

  function initCalculators() {
    var calcs = document.querySelectorAll('[data-sh-calc]');
    Array.prototype.forEach.call(calcs, function (calc) {
      var input = calc.querySelector('input[type="number"]');
      var out = calc.querySelector('[data-sh-calc-out]');
      if (!input || !out) return;
      var kitsRoot = document.querySelector(calc.dataset.shCalcTarget || '[data-sh-kits]');

      function render() {
        var m = parseFloat(String(input.value).replace(',', '.'));
        if (!isFinite(m) || m <= 0) {
          out.innerHTML = 'כתבו כמה מטר צריך לכסות ונחשב לכם.';
          highlight(null);
          return;
        }
        var kit = pickKit(m);
        if (kit) {
          out.innerHTML = 'ל-<strong><bdi>' + m + '</bdi> מטר</strong> מתאימה לכם ערכת <strong>' + kit.name + '</strong>.';
          highlight(kit.key);
        } else {
          var full = KITS[2];
          var n = Math.ceil(m / full.meters);
          out.innerHTML = 'ל-<strong><bdi>' + m + '</bdi> מטר</strong> צריך <strong><bdi>' + n + '</bdi> ערכות «בית מלא»</strong>, או כתבו לנו להצעה.';
          highlight('full');
        }
      }

      function highlight(key) {
        if (!kitsRoot) return;
        var tiles = kitsRoot.querySelectorAll('[data-kit]');
        Array.prototype.forEach.call(tiles, function (t) {
          var match = t.dataset.kit === key;
          if (t.tagName === 'INPUT') {
            if (match && !t.checked) { t.checked = true; t.dispatchEvent(new Event('change', { bubbles: true })); }
          } else {
            t.classList.toggle('is-match', match);
          }
        });
      }

      input.addEventListener('input', render);
      render();
    });
  }

  /* ---------- One reveal for the kit row ---------- */
  function initReveal() {
    var el = document.querySelector('[data-reveal]');
    if (!el) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(el);
    setTimeout(function () { el.classList.add('is-in'); }, 1500); // fallback: never leave the kits hidden
  }

  /* ---------- Product: variant tiles, price, sticky bar ---------- */
  function initProduct() {
    var form = document.querySelector('[data-sh-product-form], #sh-product-form');
    if (!form) return;
    var radios = form.querySelectorAll('input[name="sh-variant"]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEls = document.querySelectorAll('[data-sh-price]');
    var nameEls = document.querySelectorAll('[data-sh-variant-name]');
    var btn = form.querySelector('[data-sh-add]');

    function sync() {
      var r = form.querySelector('input[name="sh-variant"]:checked');
      if (!r) return;
      if (idInput) idInput.value = r.value;
      Array.prototype.forEach.call(priceEls, function (el) { el.innerHTML = '<bdi>' + r.dataset.price + '</bdi>'; });
      Array.prototype.forEach.call(nameEls, function (el) { el.textContent = r.dataset.name; });
      if (btn) {
        var available = r.dataset.available !== 'false';
        btn.disabled = !available;
        btn.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldOut;
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', r.value);
        history.replaceState(null, '', url.toString());
      } catch (e) {}
    }
    Array.prototype.forEach.call(radios, function (r) { r.addEventListener('change', sync); });
    sync();

    // Sticky bar after the buy button scrolls out
    var bar = document.querySelector('.sh-sticky-bar');
    var buy = form.querySelector('[data-sh-add]');
    if (bar && buy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var below = entries[0].boundingClientRect.top > 0 && !visible; // not yet reached
        var show = !visible && !below;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-bar', show);
      }, { threshold: 0 });
      io.observe(buy);
      var barBtn = bar.querySelector('[data-sh-sticky-add]');
      if (barBtn) barBtn.addEventListener('click', function () { buy.click(); });
    }

    // Tracking hook (Meta/TikTok pixels listen on this)
    form.addEventListener('submit', function () {
      var r = form.querySelector('input[name="sh-variant"]:checked');
      document.dispatchEvent(new CustomEvent('shiluach:add_to_cart', { detail: r ? { id: r.value, name: r.dataset.name, price: r.dataset.priceRaw } : {} }));
    });
  }

  /* ---------- Cart: terms checkbox gates checkout, hides accelerated buttons ---------- */
  function initCartTerms() {
    var box = document.querySelector('[data-sh-terms]');
    if (!box) return;
    var cb = box.querySelector('input[type="checkbox"]');
    if (!cb) return;

    function checkoutButtons() {
      return document.querySelectorAll('button[name="checkout"], input[name="checkout"], [data-sh-checkout], a[href="/checkout"], a[href$="/checkout"]');
    }
    function hideAccelerated() {
      var sel = '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .dynamic-checkout__content, [data-shopify="dynamic-checkout-cart"], #dynamic-checkout-cart';
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) { el.style.display = 'none'; el.setAttribute('aria-hidden', 'true'); });
    }
    function apply() {
      var ok = cb.checked;
      Array.prototype.forEach.call(checkoutButtons(), function (b) {
        if (b.tagName === 'A') { b.setAttribute('aria-disabled', ok ? 'false' : 'true'); b.classList.toggle('is-disabled', !ok); }
        else { b.disabled = !ok; b.setAttribute('aria-disabled', ok ? 'false' : 'true'); }
      });
      box.classList.toggle('is-invalid', false);
      hideAccelerated();
    }
    cb.addEventListener('change', apply);
    apply();
    // Re-apply when the cart re-renders (Shopify sections re-render on quantity change)
    var mo = new MutationObserver(function () { apply(); });
    mo.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('button[name="checkout"], [data-sh-checkout], a[href$="/checkout"]');
      if (t && !cb.checked) { e.preventDefault(); e.stopPropagation(); box.classList.add('is-invalid'); cb.focus(); }
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && /\/checkout/.test(f.getAttribute('action') || '') && !cb.checked) { e.preventDefault(); box.classList.add('is-invalid'); cb.focus(); }
      if (f && f.matches && f.matches('form[action*="/cart"]') && e.submitter && e.submitter.name === 'checkout' && !cb.checked) { e.preventDefault(); box.classList.add('is-invalid'); cb.focus(); }
    }, true);
  }

  /* ---------- Gallery (product) ---------- */
  function initGallery() {
    var g = document.querySelector('.sh-gallery');
    if (!g) return;
    var main = g.querySelector('.sh-gallery__main');
    var thumbs = g.querySelectorAll('.sh-gallery__thumb');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        Array.prototype.forEach.call(thumbs, function (x) { x.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        var kind = t.dataset.kind || 'image';
        if (kind === 'video') {
          main.innerHTML = '<video controls playsinline preload="metadata" poster="' + (t.dataset.poster || '') + '"><source src="' + t.dataset.src + '"></video>';
        } else {
          var img = main.querySelector('img');
          if (!img) { main.innerHTML = '<img alt="">'; img = main.querySelector('img'); }
          img.src = t.dataset.src; img.alt = t.dataset.alt || '';
          if (t.dataset.srcset) img.srcset = t.dataset.srcset; else img.removeAttribute('srcset');
        }
      });
    });
  }

  function init() {
    initHeader();
    initHero();
    initCalculators();
    initReveal();
    initProduct();
    initCartTerms();
    initGallery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Shopify theme editor: re-init when a section is reloaded
  document.addEventListener('shopify:section:load', init);
})();